.row {
  display: flex;
  flex-flow: row wrap;
  min-width: 0;

  &.noWrap {
    flex-wrap: nowrap;
  }

  &.justifyStart {
    justify-content: flex-start;
  }

  // The center of the X-axis
  &.justifyCenter {
    justify-content: center;
  }

  // The opposite of the X-axis
  &.justifyEnd {
    justify-content: flex-end;
  }

  &.justifySpaceBetween {
    justify-content: space-between;
  }

  &.justifySpaceAround {
    justify-content: space-around;
  }

  &.justifySpaceEvenly {
    justify-content: space-evenly;
  }

  &.alignTop {
    align-items: flex-start;
  }

  // Align at the center
  &.alignMiddle {
    align-items: center;
  }

  &.alignBottom {
    align-items: flex-end;
  }
}

.col {
  position: relative;
  max-width: 100%;
  min-height: 1px;

  @colnums: range(24);
  @sizes: {
    Sm: 576px;
    Md: 768px;
    Lg: 992px;
    Xl: 1200px;
    Xxl: 1600px;
  };

  &.generalSpan0 {
    display: none;
  }
  &.generalOffset0 {
    margin-left: 0;
  }

  each(@colnums, #(@colnum) {
    &.generalSpan@{colnum} {
      display: block;
      flex: 0 0 percentage((@colnum / 24) );
      max-width: percentage((@colnum / 24) );
    }
    &.generalOffset@{colnum} {
      margin-left: percentage((@colnum / 24) );
    }
  });

  &.sizeSpanXS0 {
    display: none;
  }
  &.sizeOffsetXS0 {
    margin-left: 0;
  }

  each(@colnums, #(@colnum) {
    &.sizeSpanXs@{colnum} {
      display: block;
      flex: 0 0 percentage((@colnum / 24) );
      max-width: percentage((@colnum / 24) );
    }
    &.sizeOffsetXs@{colnum} {
      margin-left: percentage((@colnum / 24) );
    }
  });

  each(@sizes, {
    @media (min-width: @value) {
      @size: @key;
      @zero: 0;
      &.sizeSpan@{size}@{zero} {
        display: none;
      }
      &.sizeOffset@{size}@{zero} {
        margin-left: 0;
      }
      each(@colnums, #(@colnum) {
        &.sizeSpan@{size}@{colnum} {
          display: block;
          flex: 0 0 percentage((@colnum / 24) );
          max-width: percentage((@colnum / 24) );
        }
      });
      each(@colnums, #(@colnum) {
        &.sizeOffset@{size}@{colnum} {
          margin-left: percentage((@colnum / 24) );
        }
      });
    }
  });
}
